import EmployeesGateway from './EmployeesGateway'
import employeeModel from './EmployeeModel'

export default class EmployeesService {
  constructor (employeesGateway) {
    this.EmployeesGateway = employeesGateway || new EmployeesGateway()

    this.getAllEmployees = this.getAllEmployees.bind(this)
    this.getEmployeesById = this.getEmployeesById.bind(this)
    this.getOrganizationEmployeesById = this.getOrganizationEmployeesById.bind(this)
    this.updateEmployee = this.updateEmployee.bind(this)
    this.moveEmployee = this.moveEmployee.bind(this)
    this.deleteEmployee = this.deleteEmployee.bind(this)
    this.addEmployee = this.addEmployee.bind(this)
    this.assignTag = this.assignTag.bind(this)
    this.removeTag = this.removeTag.bind(this)
    this.deleteEmployeeList = this.deleteEmployeeList.bind(this)
    this.addEmployeeWithManager = this.addEmployeeWithManager.bind(this)
    this.removeEmployeesFromTag = this.removeEmployeesFromTag.bind(this)
    this.uploadEmployees = this.uploadEmployees.bind(this)
    this.employeesExportExcel = this.employeesExportExcel.bind(this)
    this.getUnassignedEmployees = this.getUnassignedEmployees.bind(this)
    this.getAssignedEmployees = this.getAssignedEmployees.bind(this)
    this.uploadEmployeesAppend = this.uploadEmployeesAppend.bind(this)
  }
  getAssignedEmployees (params) {
    return this.EmployeesGateway
    .getAssignedEmployees(params)
    .then(response => response.map(item => employeeModel(item)))
  }

  getUnassignedEmployees () {
    return this.EmployeesGateway
    .getUnassignedEmployees()
    .then(response => response.map(item => employeeModel(item)))
  }

  employeesExportExcel () {
    return this.EmployeesGateway
    .employeesExportExcel()
    .then(response => response)
  }

  uploadEmployees (query) {
    return this.EmployeesGateway
    .uploadEmployees(query)
    .then(response => response)
  }

  uploadEmployeesAppend (query) {
    return this.EmployeesGateway
    .uploadEmployeesAppend(query)
    .then(response => response)
  }

  removeEmployeesFromTag (query) {
    return this.EmployeesGateway
    .removeEmployeesFromTag(query)
    .then(response => response)
  }

  addEmployeeWithManager (query) {
    return this.EmployeesGateway
    .addEmployeeWithManager(query)
    .then(response => response)
  }

  removeTag (query) {
    return this.EmployeesGateway
    .removeTag(query)
    .then(response => response)
  }

  assignTag (query) {
    return this.EmployeesGateway
    .assignTag(query)
    .then(response => response)
  }

  getAllEmployees () {
    return this.EmployeesGateway
      .getAllEmployees()
      .then(response => response.map(item => employeeModel(item)))
  }

  getEmployeesById (params) {
    return this.EmployeesGateway
    .getEmployeesById(params)
    .then(response => response.map(item => ({
      ...employeeModel(item.employee),
      alternativeCampaignName: item.alternativeCampaignName
    })))
  }

  getOrganizationEmployeesById (params) {
    return this.EmployeesGateway
      .getOrganizationEmployeesById(params)
      .then(response => response.map(item => employeeModel(item)))
  }

  updateEmployee (query) {
    return this.EmployeesGateway
      .updateEmployee(query)
      .then(response => response)
  }

  moveEmployee (query) {
    return this.EmployeesGateway
      .moveEmployee(query)
      .then(response => response)
  }

  deleteEmployee (query) {
    return this.EmployeesGateway
      .deleteEmployee(query)
      .then(response => response)
  }

  deleteEmployeeList (query) {
    return this.EmployeesGateway
      .deleteEmployeeList(query)
      .then(response => response)
  }

  addEmployee (query) {
    return this.EmployeesGateway
      .addEmployee(query)
      .then(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/api/employees/EmployeesService.js